import OptimizeEntities from '../entities/optimize'

class CommonService {
    constructor() {
        this.entities = new OptimizeEntities();
    }
    /**获取机构（供货、要货、管辖机构等）  */
    async getOrganiztion(params) {
        return await this.entities.getOrganiztion(params)
    }

    /**供货机构（供应商）下拉框 - 加载数据 */
    async getSublevel(params) {
        return await this.entities.getSublevel(params)
    }
    /**仓库下拉框 - 加载数据 */
    async getwarehouse(params) {
        return await this.entities.getwarehouse(params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据 */
    async getCategory(params) {
        return await this.entities.getCategory(params)
    }
    async getBumen(params) {
        return await this.entities.getBumen(params)
    }
    async getBiaoqian(params) {
        return await this.entities.getBiaoqian(params)
    }
    async getYuanyin(params) {
        return await this.entities.getYuanyin(params)
    }
    async getWupin(params) {
        return await this.entities.getWupin(params)
    }
    async getCaipin(params) {
        return await this.entities.getCaipin(params)
    }
    async getWaixiaokehu(params) {
        return await this.entities.getWaixiaokehu(params)
    }
    async getItems(params, type) {
        return await this.entities.getItems(params, type)
    }
}
export default CommonService;


// WEBPACK FOOTER //
// ./src/logics/services/common.js